<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Equipment Handover to Collaborator</h5>

    <br/>
    <br/>

    <ul>
      <li>Click the relevant field before scanning</li>
      <li>Press Enter to verify the scanned code</li>
      <li>Press Esc to clear the form</li>

    </ul>

    <br/>
    <br/>

    <form >

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Supplier - Contractor</label>
          <select class="custom-select" (change)="ReadData_Contractor_Customer()" [(ngModel)]="Selected_Contractor_Id" name="Selected_Contractor_Id" >
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Contractor" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

        <div class="form-group col-md-4" >
          <label for="exampleInputEmail1">Supplier - Customer</label>
          <select class="custom-select" [(ngModel)]="Selected_Contractor_Customer_Id" name="Selected_Contractor_Customer_Id" >
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_Contractor_Customer" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Request Subject </label>
          <select class="custom-select" (change)="SubjectLetter_Change()" [(ngModel)]="SubjectLetter_Id" name="SubjectLetter_Id">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_SubjectLetter" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

      </div>


      <div class="row" >
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Click the field below before scanning the QR code <i class="fa fa-arrow-down"></i>
          </label>
          <input #QRCodeInputDownload type="text" (keyup.enter)="QRCodeInputDownload_Enter()" (keyup.esc)="QRCodeInputDownload_Esc()"
            style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;" class="form-control EnglishClm"
            placeholder="Click here...">
          <p [hidden]="!Procssing"> Please wait... <i class="fa fa-spin fa-refresh"></i> </p>

        </div>
      </div>

      <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeChangeDownload()" type="button" [disabled]="Info_Download_List.length==0 || Selected_Contractor_Customer_Id=='0' || SubjectLetter_Id=='0'" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Entry of Scanned Equipment </button>

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeInputDownload_Enter()" type="button"
      class="btn btn-info" style="margin-right: 5px;"><i
       class="fa  fa-plus-circle"></i> Verify Instrument ID </button>

      <button *ngIf="!Procssing && FormSubmitted" (click)="ResetForm()" type="button"  class="btn btn-danger" style="margin-right: 5px;"><i class="fa  fa-recycle"></i> Start Over </button>

      <button routerLink="/LabDownloadUploadDevice" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>

    <br/>
    <br/>

    <div class="row" *ngIf="Info_Download_List.length>0">
      <div class="form-group col-md-12">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Instrument Name</th>
                <th>Instrument Code</th>
                <th>Instrument Serial Number</th>
                <th *ngIf="!FormSubmitted">User Description</th>
                <th *ngIf="!FormSubmitted">QR Code</th>
                <th *ngIf="FormSubmitted">System Message</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Info_Download_List">
                <td>{{Info_Download_List.indexOf(item)+1}}</td>
                <td>{{item.userDsc}}</td>
                <td>{{item.code}}</td>
                <td>{{item.title}}</td>
                <td *ngIf="item.id==0">
                  <input type="text" class="form-control" [(ngModel)]="item.userDsc" placeholder="Type here..." />
                </td>

                <td *ngIf="item.id==0">{{item.dsc}}</td>
                <td *ngIf="item.id>0" style="color: green;">{{item.dsc}}</td>
                <td *ngIf="item.id<0" style="color: red;">{{item.dsc}}</td>
                <td>
                  <button  *ngIf="!FormSubmitted" (click)="Info_Download_Remove(Info_Download_List.indexOf(item))" class="btn btn-danger"><i class="fa fa-remove"></i> Delete </button>
                </td>

              </tr>
            </tbody>
          </table>
       </div>
      </div>
    </div>


    <a *ngFor="let item of Info_Download_List_Letter_Id" href="{{PrintURl}}{{item}}" target="_blank"
      style="margin-right: 5px;"> <button type="button" class="btn btn-danger"><i class="fa fa-file-pdf-o"></i>
        Request PDF No. {{item}}
      </button> </a>


  </div>
</div>
